import type { SxProps, Theme } from "@mui/material";

import BaseCell from "./BaseCell";

interface Props {
    value?: string;
    sx?: SxProps<Theme>;
    className?: string;
    helperText?: string;
}

export default function DisplayCell({ value, sx, className, helperText }: Props) {
    return (
        <BaseCell sx={sx} className={className} helperText={helperText}>
            <div className="h-full flex items-center justify-center">
                <p data-testid="display-cell-value">{value ?? ""}</p>
            </div>
        </BaseCell>
    );
}
